import { gql, TypedDocumentNode } from '@apollo/client'
import type { CommitteeFragment } from './__generated__/CommitteeFragment'

export const committeeFragment: TypedDocumentNode<CommitteeFragment> = gql`
  fragment CommitteeFragment on Committee {
    averageWeeklyHours
    averageWeeklyHoursByYear
    code
    id
    isConstructAllowed
    isFlexiAllowed
    isWorker
    name
    overtimePayingStatus
  }
`
